import MainNavbar from '../userNavBar/MainNavbar'
import TopNavbar from '../userNavBar/TopNavbar'

const UserNavBar = () => {
  return (
    <nav  className='w-full sticky top-0 z-50 font-KumbhSans shadow-md'>
      <TopNavbar />
      <MainNavbar />
    </nav>
  )
}

export default UserNavBar